<template>
  <div :class="['row',  addclass]">
    <div class="col-2 padd-0" v-if="!delaysetting && title != ''">
      <p style="text-align: left;margin-top: 7px;">{{title}}:</p>
    </div>

    <div class="col-3 padd-0" v-if="delaysetting">
      <b-form-select
        v-model="time.days"
        :options="FormDelayTimeOptions('days')"
        class="mb-3"
        :disabled="!allowed"
      ></b-form-select>
      <!-- <span id="spanId" style="float:right;">:</span> -->
    </div>
    <div
      class="col-1"
      style="padding-top: 5px;padding-left: 5px;padding-right: 5px;"
      v-if="delaysetting"
    >:</div>
    <div :class="[title != '' ? 'col-3' : 'col-4', 'padd-0']">
      <!-- id="flp--aval-from-hours" -->
      <b-form-select
        v-model="time.hours"
        :options="FormDelayTimeOptions('hours-ampm')"
        class="mb-3"
        :disabled="!allowed"
      ></b-form-select>
    </div>
    <div class="col-1" style="padding-top: 5px;padding-left: 5px;padding-right: 5px;">:</div>

    <div :class="[title != '' ? 'col-3' : 'col-4', 'padd-0']">
      <!-- id="flp-aval-from-minutes" -->
      <b-form-select
        v-model="time.minutes"
        :options="FormDelayTimeOptions('minutes')"
        class="mb-3"
        :disabled="!allowed"
      ></b-form-select>
    </div>
    <div class="col-3" style="padding-left: 10px;padding-right: 0px;" v-if="!delaysetting">
      <!-- id="flp-aval-from-ampm" -->
      <b-form-select
        v-model="time.ampm"
        :options="['am', 'pm']"
        class="mb-3 no-border"
        style="padding-left:10px;"
        :disabled="!allowed"
      ></b-form-select>
    </div>
  </div>
  <!-- </div>
  </div>-->
</template>

<script>
export default {
  name: "SetTimeBox",
  components: {},
  props: {
    value: Object,
    allowed: Boolean,
    title: String,
    addclass: String,
    delaysetting: Boolean
  },
  data() {
    return {
      time: {}
    };
  },

  watch: {
    // allowed: function(val) {
    //   this.MsgInputBoxStyling(val);
    // }
  },

  mounted() {
    this.time = this.value;
  },

  methods: {
    FormDelayTimeOptions(m) {
      let r = [];
      if (m.includes("days")) {
        for (let i = 0; i < 32; i++) {
          r.push(i.toString());
        }
      } else if (m.includes("hours")) {
        let kk = m == "hours" ? 24 : 13;
        let k = m == "hours" ? 0 : 1;
        for (let i = k; i < kk; i++) {
          r.push(i.toString());
        }
      } else {
        for (let i = 0; i < 60; i = i + 5) {
          r.push(i < 10 ? "0" + i.toString() : i.toString());
        }
      }
      return r;
    }
  }
};
</script>
<style scoped>
.padd-0 {
  padding: 0;
}
.aval-from-style {
  padding-left: 0px;
  padding-right: 3px;
  border-right: 1px solid lightgrey;
}

.aval-till-style {
  padding-left: 7px;
  padding-right: 0;
}
.no-border {
  border: 0;
  border-radius: 0;
  /* border-bottom: 1px solid; */
}
.mt15 {
  margin-top: 15px;
}
</style>




